/**
 * Cross-Course GPA-Protective Skip Allocator (FE-E2 / TODO-13).
 *
 * Shows the per-absence GPA cost for each course so the student knows which
 * class is cheapest to skip when forced to choose.
 */

import React from 'react';
import { useAppStore } from '@/store';
import { selectPerAbsenceGPACost } from '@/store/selectors';
import { RiskBadge, EmptyState } from '../shared';

export function GpaSkipAllocatorPanel(): React.ReactElement {
  const costs = useAppStore((s) => selectPerAbsenceGPACost(s));

  if (costs.length === 0) {
    return (
      <div className="gpa-skip-allocator">
        <h4>Cheapest Class to Skip</h4>
        <EmptyState
          title="No GPA cost data"
          description="Set base grades to see per-absence GPA cost."
        />
      </div>
    );
  }

  return (
    <div className="gpa-skip-allocator" role="region" aria-label="GPA-Protective Skip Allocator">
      <h4>Cheapest Class to Skip</h4>
      <p className="stat-caption">If you have to skip one class, skip the cheapest.</p>
      <table className="gpa-skip-allocator__table">
        <thead>
          <tr>
            <th scope="col">Course</th>
            <th scope="col">Credits</th>
            <th scope="col">Risk</th>
            <th scope="col">GPA cost/absence</th>
          </tr>
        </thead>
        <tbody>
          {costs.map((c) => (
            <tr key={c.courseId}>
              <td>{c.courseName}</td>
              <td>{c.creditHours}</td>
              <td><RiskBadge level={c.riskLevel} size="sm" /></td>
              <td>{c.gpaCostPerAbsence.toFixed(3)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
